import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";
import { getSettingsCollection, getWebsite } from "@toolkit/Framework/Store/Context/ContextSelectors";

export const useSettingsCollection = convertSelectorToHook(getSettingsCollection);
export const useWebsite = convertSelectorToHook(getWebsite);
